"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.readDealerIdFromStorage = exports.writeDealerIdToStorage = exports.DEALER_ID_SESSION_STORAGE_KEY = void 0;
exports.DEALER_ID_SESSION_STORAGE_KEY = 'dealer-context';
function writeDealerIdToStorage(dealerId) {
    try {
        if (dealerId) {
            sessionStorage.setItem(exports.DEALER_ID_SESSION_STORAGE_KEY, JSON.stringify(dealerId));
        }
        else {
            sessionStorage.removeItem(exports.DEALER_ID_SESSION_STORAGE_KEY);
        }
    }
    catch (_a) { }
}
exports.writeDealerIdToStorage = writeDealerIdToStorage;
function readDealerIdFromStorage() {
    try {
        const stringifiedDealerId = sessionStorage.getItem(exports.DEALER_ID_SESSION_STORAGE_KEY);
        return stringifiedDealerId ? JSON.parse(stringifiedDealerId) : undefined;
    }
    catch (_a) { }
}
exports.readDealerIdFromStorage = readDealerIdFromStorage;
//# sourceMappingURL=storage.js.map